export const homePageTranslationsEn = {
  homeNavLabel: 'Home',
  purchaseOrdersNavLabel: 'Purchase Orders',
  notificationsLabel: 'Notifications',
  quickActionsLabel: 'Quick actions',
  ordersTableLabel: 'Orders table',
  purchaseOrdersTableAriaLabel: 'Purchase orders table',
  noOrdersFound: 'No orders found',
  timeNote: 'All times are shown in Pacific Time (PT).',
  timeNotePT: 'All times are shown in Pacific Time (PT).',
  timeNoteGMT: 'All times are shown in Greenwich Mean Time (GMT).',
  refreshButtonLabel: 'Refresh',
  refreshIconAlt: 'Refresh icon',
  bannerTitle: 'CHiME agent',
  bannerSubtitle:
    'This is your workspace to review, validate, and manage Purchase Orders. Check your queue regularly to stay up to date with pending requests.',
  notificationScheduledTitle: 'Scheduled maintenance',
  notificationScheduledText: 'Chime Agent will be unavailable today from 10:00 PM to 11:00 PM PT.',
  notificationOrdersTitle: 'Unable to load all Purchase Orders',
  notificationOrdersText: 'Some items may not be displayed at the moment. Please refresh the page or try again later.',
  tileMyTasksTitle: '15 Open Orders',
  tileMyTasksDescription: 'Orders currently in progress that may require your attention.',
  tileMyTasksLink: 'Review open orders',
  tileReportsTitle: 'Recently closed',
  tileReportsDescription: 'Orders completed or rejected within the last 6 months.',
  tileReportsLink: 'View closed orders',
  tileSettingsTitle: 'All orders',
  tileSettingsDescription: 'See open and closed orders from the last 6 months.',
  tileSettingsLink: 'View all orders',
  tableRequestDateHeader: 'Request date and time',
  tableShipToHeader: 'Ship-to',
  tablePoNumberHeader: 'PO#',
  tableValidatedByHeader: 'Being reviewed by',
  tableCommentHeader: 'Comment',
  tableStatusHeader: 'Status',
  statusReadyForReview: 'Ready for review',
};
